import PointCloudView from "./PointCloudView";

export default PointCloudView;